module.exports = __webpack_public_path__ + "static/media/iitm-logo.148bfaee.jpg";